export enum ClaimReviewUpdateMessageType {
  Payee = 'Payee changed',
  ProNumber = 'PRO changed',
  ClaimRequestAmount = 'Claim Request Amount changed',
  SvcCenterChargeabilityAllocation = 'Chargeability Allocation changed',
  PaymentGreaterThanLiability = 'Payout more than Total Liability',
  PayoutAmount = 'Escalated for Payout Amount',
}
